module.exports = __webpack_public_path__ + "img/play.ac16ede8.svg";